import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  tab: 0,
  clickedTab: 0,
  tabsData: []
};

export const tabs = createSlice({
  name: 'tabs',
  initialState,
  reducers: {
    reset: state => {
      state.tab = 0;
    },
    setTab: (state, action: PayloadAction<number>) => {
      state.tab = action.payload;
    },
    setClickedTab: (state, action: PayloadAction<number>) => {
      state.clickedTab = action.payload;
    },
    setTabsData: (state, action: PayloadAction<any>) => {
      state.tabsData = action.payload;
    }
  }
});

export const { reset, setTab, setClickedTab, setTabsData } = tabs.actions;
